import { Components } from '@mui/material';
import { getResponsiveFontSize } from '../../shared/utils';

export const MuiSvgIcon: Components['MuiSvgIcon'] = {
  styleOverrides: {
    root: {
      fontSize: getResponsiveFontSize('1.5rem'),
    },
    fontSizeSmall: { fontSize: getResponsiveFontSize('1.25rem') },
    fontSizeLarge: { fontSize: getResponsiveFontSize('2.1875rem') },
    fontSizeInherit: { fontSize: getResponsiveFontSize('1rem') },
  },
};
